/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Widget/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromFormat from 'Data/format.js'
import Ach from './Ach/index'
import Card from './Card/index'
import Cash from './Cash/index'
import Check from './Check/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Widget({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/PaymentsTreatmentPlan/Content/TreatmentPayments/Content/Content/SetupPayment/ActiveStep/DownpaymentSetup/Pay/ChooseType/Widget"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let payersActivetabDownpaymentMetadataTypeValueData = fromData.useDataFormat({ viewPath,
context: 'payers',
path: 'activeTab.downpayment_metadata.type',
format: fromFormat.capitalize,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: payersActivetabDownpaymentMetadataTypeValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Card'}>
<Card
  viewPath={`${viewPath}/Card`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Cash'}>
<Cash
  viewPath={`${viewPath}/Cash`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Check'}>
<Check
  viewPath={`${viewPath}/Check`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Ach'}>
<Ach
  viewPath={`${viewPath}/Ach`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}